module.exports = __webpack_public_path__ + "static/media/transactionIcon.2e8643a5.svg";